import { useTheme } from "@mui/material";
import type { DrivingSchoolLabel } from "../providers/drivingSchoolsProvider";

export type StudentLabelPalette = Record<DrivingSchoolLabel["color"], { background: string; text: string }>;

export function useStudentLabelPalette(): StudentLabelPalette {
  const theme = useTheme();
  return (
    theme.palette as typeof theme.palette & {
      studentLabels: StudentLabelPalette;
    }
  ).studentLabels;
}
